export function isShippingTrackerFieldTypeId(fieldDataTypeId: string | undefined): boolean {
  return fieldDataTypeId === 'shippingTrackerCompact' || fieldDataTypeId === 'shippingTrackerExpanded';
}
